import React, {Component} from 'react';
import {Col, Row, Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';

//CSS
import '../../../assets/css/ProductoStandart.css';


//assets
import dobleProducto from '../../../assets/img/productos/dobleProducto2.png';
import portada from '../../../assets/img/productos/strack.png';
import btnDescarga from '../../../assets/img/productos/btnDescarga.png';
import btnDescargaOsc from '../../../assets/img/productos/btnDescargaGrey.png';
import hr from '../../../assets/img/productos/hr.png';
import logo25 from '../../../assets/img/logo25prod.png';

//Import Components
import Galeria from '../../elementos/Galeria';
import SliderFinan from "../../elementos/SliderFinan";


//Import Imagenes Galeria
import foto1 from '../../../assets/img/galeria/strack/foto1.png';
import foto2 from '../../../assets/img/galeria/strack/foto2.png';
import foto3 from '../../../assets/img/galeria/strack/foto3.png';
import foto4 from '../../../assets/img/galeria/strack/foto4.png';

import valor1 from '../../../assets/img/valores/strack/valor1.png';
import valor2 from '../../../assets/img/valores/strack/valor2.png';

const photos = [
    {src: foto1, width: 4, height: 3},
    {src: foto2, width: 4, height: 3},
    {src: foto3, width: 4, height: 3},
    {src: foto4, width: 4, height: 3}
];

class Strack extends Component {

    componentDidMount() {
        document.title = "Strack - Sensor Tecnología";
        window.scrollTo(0, 0);
    }

    realiceSuConsulta(){
        var data =  {
            content_category: 'clics',
            content_name: 'bt-realice-consulta'
        };
        ReactPixel.track( 'Lead', data );

        ReactGA.event({
            action:'consultar',
            category: 'clics',
            label: 'bt-realice-consulta'
        });
    }

    render() {
        return (
            <div>
                <section className="productos productos-std">
                    <div className="home-producto" style={{paddingBottom: "60px"}}>
                        <Row>
                            <Col md={6}>
                                <div className="img-producto">
                                    <img className="img-responsive" src={portada} alt=""/>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="tit-producto">
                                    <h1>
                                        <span>{this.context.t('Telemetría')}</span>
                                        <img src={logo25} alt=""/>
                                        </h1>
                                    <h1>{this.context.t('S-Trak')}</h1>
                                    <img src={hr} alt=""/>
                                    <p>{this.context.t('Mas observación, comunicación y rendimiento.')}</p>
                                    <p className="tit-dsc">{this.context.t('Adquisición y trasmisión de información para verificación on line a distancia.')}</p>
                                    <p className="dsc">{this.context.t('El Sistema Telemétrico S-Trak se conecta al bus de comunicación de los sistemas Multiplex Sensor, para transmitir diversas variables que otros sistemas de tracking no pueden. Esta información puede ser vista al instante y también puede configurarse para visualizarse en PC, Tablet o Smartphone.')}
                                    </p>
                                    <br/><br/>
                                    <Col md={6} className="no-padding-left">
                                        <Link to="/contacto" onClick={() => this.realiceSuConsulta()}>
                                            <Button>{this.context.t('Realice su consulta')}</Button>
                                        </Link>
                                    </Col>
                                </div>

                            </Col>
                        </Row>
                    </div>
                    <div className="home-gallery">
                        <Galeria photos={photos}/>
                    </div>

                    <div className="productos-caracteristicas">
                        <div className="container-limit">
                            <Row>
                                <Col md={6}>
                                    <div className="caracteristicas-descripcion">
                                        <h3>{this.context.t('Capacidad de acción')}</h3>
                                        <div className="red-line3"></div>
                                        <p className="sinBorde">
                                            {this.context.t('Los datos que el sistema envía permiten al usuario saber lo que está sucediendo en tiempo real, pudiendo reaccionar a tiempo ante alguna eventualidad que el sistema indique.')}
                                        </p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="img-graficos">
                                        <img className="img-responsive" src={valor1} alt=""/>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <div className="caracteristicas-descripcion" style={{marginTop: "60px"}}>
                                        <h3>{this.context.t('Inversión que produce beneficios')}</h3>
                                        <div className="red-line3"></div>
                                        <p className="sinBorde">
                                            {this.context.t('El sistema S-Trak fue diseñado para reducir tiempos dedicados a mantenimiento y costos logísticos operativos.')}
                                        </p>
                                    </div>
                                </Col>

                                <Col md={6}>
                                    <div className="img-graficos">
                                        <img className="img-responsive" src={valor2} alt=""/>
                                    </div>
                                </Col>
                            </Row>

                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default Strack;